export default __webpack_public_path__ + "static/media/Like-Selected.332b8336.svg";